import styled from "@emotion/styled";
import theme from "@utils/theme";
import { Plus } from "lucide-react";

export const Wrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  ${(props: any) => props.styleWrapper}
`;

export const Label = styled.label<{ hasError?: boolean }>`
  font-size: 14px;
  color: ${({ hasError }) => (hasError ? "red" : "#333")};
`;

export const InputWrapper = styled.div<{ hasError?: boolean }>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-height: 32px;
  gap: 6px;
  padding: 4px 8px;
  border: 1px solid ${({ hasError }) => (hasError ? "red" : "#ddd")};
  border-radius: 6px;
  margin-top: 5px;
  width: 100%;
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  background: #ffe6e6;
  border: 1px solid #ffcccc;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 13px;
  color: #a80000;
  cursor: default;

  svg {
    margin-left: 6px;
    cursor: pointer;
  }
`;

export const StyledInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  padding: 4px;
  &::placeholder {
    font-size: 12px;
    color: ${(props: any) => props.theme.colors.placeholder};
    letter-spacing: 0.25px;
    line-height: 16px;
  }
  position: relative;
`;

export const PlusIcon = styled(Plus)`
  cursor: pointer;
  color: #a80000;
`;

export const SuggestionsList = styled.div`
  position: absolute;
  top: 150%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #ccc;
  z-index: 10;
  max-height: 150px;
  overflow-y: auto;
  border-radius: 4px;
`;

export const SuggestionItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  font-size: 12px;
  &:hover {
    background-color: #f2f2f2;
  }
`;
